export default __webpack_public_path__ + "static/media/haeuser_intro_web-md@2x.efaf887e.webp";